import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Collapse } from 'react-bootstrap';
import './CloseoutContribForm.css';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faAngleDown from '@fortawesome/fontawesome-free-solid/faAngleDown';
import faAngleUp from '@fortawesome/fontawesome-free-solid/faAngleUp';
import removeIconPng from 'images/remove.png';
import uploadSvg from 'images/upload.svg';
import TextareaAutosize from 'react-autosize-textarea';
import LabeledCheckBox from 'components/shared/checkbox/LabeledCheckBox';
import DocumentLink from 'components/shared/document/DocumentLink';
import Dropzone from 'react-dropzone';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import MessageModal from 'components/shared/modal/MessageModal';
import invalidPng from 'images/invalid.png';
import { Enterprise } from 'domain/enterprise';
import { getCurrentProject } from 'components/admin/projects/details/store/selectors';
import {
  updateCloseoutContrib,
  closeoutPercentage,
} from 'components/admin/projects/details/project-closeout/store/actions';

class CloseoutContribForm extends Component {
  static propTypes = {
    closeoutContrib: PropTypes.shape({}).isRequired,
  };

  constructor(props) {
    super(props);
    const { currentProject } = props;
    this.state = {
      contribForm: this.initializeContribForm(props.closeoutContrib),
      showForm:
        currentProject &&
        Enterprise.subcontractor(currentProject.contributor_type),
      showRemoveConfirmation: false,
      showInvalidDocsMsg: false,
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { closeoutContrib } = this.props;
    const newCloseoutContrib = newProps.closeoutContrib;
    if (closeoutContrib !== newCloseoutContrib) {
      this.setState({
        contribForm: this.initializeContribForm(newCloseoutContrib),
      });
    }
  }

  initializeContribForm = (closeoutContrib) => {
    const contribForm = { comments: closeoutContrib.comments };
    closeoutContrib.closeout_contributor_cats.forEach((contribCat) => {
      contribForm[contribCat.id] = {};
      contribForm[contribCat.id].documents = contribCat.documents.map((doc) => {
        return {
          ...doc,
          url: doc.document.url,
        };
      });
      contribForm[contribCat.id].applies = contribCat.applies;
      contribForm[contribCat.id].comments = contribCat.comments;
    });
    return contribForm;
  };

  handleContribFormChange = (attr, value, callback) => {
    this.setState(
      {
        contribForm: {
          ...this.state.contribForm,
          [attr]: value,
        },
      },
      callback
    );
  };

  handleContribFormCatChange = (categoryId, attr, value, callback) => {
    this.setState(
      {
        contribForm: {
          ...this.state.contribForm,
          [categoryId]: {
            ...this.state.contribForm[categoryId],
            [attr]: value,
          },
        },
      },
      callback
    );
  };

  getArrayAttribute = (categoryId, attr) => {
    const { contribForm } = this.state;
    const contribFormCat = contribForm[categoryId];
    if (
      contribFormCat &&
      contribFormCat[attr] &&
      contribFormCat[attr].length > 0
    ) {
      return contribFormCat[attr];
    }
    return [];
  };

  setDocuments = (categoryId, files) => {
    const docs = [...this.getArrayAttribute(categoryId, 'documents')];
    files.forEach(function (val) {
      docs.push({
        file: val,
        name: val.name,
      });
    });
    this.handleContribFormCatChange(
      categoryId,
      'documents',
      docs,
      this.handleSave
    );
  };

  removeDocument = (confirmed) => {
    if (confirmed) {
      const { categoryId, index } = this.state;
      const docs = [...this.getArrayAttribute(categoryId, 'documents')];
      const deletedDocs = [
        ...this.getArrayAttribute(categoryId, 'deletedDocuments'),
      ];
      const deletedDoc = docs.splice(index, 1);
      deletedDocs.push(deletedDoc[0]);

      this.handleContribFormCatChange(categoryId, 'documents', docs, () =>
        this.handleContribFormCatChange(
          categoryId,
          'deletedDocuments',
          deletedDocs,
          this.handleSave
        )
      );
    }
    this.setState({ showRemoveConfirmation: false });
  };

  confirmRemoveDocument = (categoryId, index) => {
    this.setState({
      showRemoveConfirmation: true,
      categoryId: categoryId,
      index: index,
    });
  };

  handleSave = () => {
    const { currentProject, closeoutContrib, dispatch } = this.props;
    const { contribForm } = this.state;
    dispatch(
      updateCloseoutContrib(currentProject.id, closeoutContrib, contribForm)
    ).then((response) => {
      if (response.ok) {
        dispatch(closeoutPercentage(currentProject.id));
      }
    });
  };

  showForm = () => {
    this.setState({ showForm: !this.state.showForm });
  };

  handleShowInvalidDocsMsg = () => {
    this.setState({ showInvalidDocsMsg: true });
  };

  handleDismissInvalidDocsMsg = () => {
    this.setState({ showInvalidDocsMsg: false });
  };

  render() {
    const { currentProject, closeoutContrib } = this.props;
    const {
      contribForm,
      showForm,
      showRemoveConfirmation,
      showInvalidDocsMsg,
    } = this.state;
    const subcontractor =
      currentProject &&
      Enterprise.subcontractor(currentProject.contributor_type);
    const readOnly =
      currentProject && Enterprise.primary(currentProject.contributor_type);
    return (
      <div className="closeout-contrib-form">
        <div className="closeout-contrib-form-header" onClick={this.showForm}>
          <span className="closeout-contrib-form-toggle">
            <FontAwesomeIcon icon={showForm ? faAngleUp : faAngleDown} />
          </span>
          <h4>
            {closeoutContrib.csi_code_division} {closeoutContrib.csi_code_label}
            {!subcontractor && (
              <span>
                {' '}
                - <b>{closeoutContrib.company_name}</b>
              </span>
            )}
          </h4>
        </div>
        <Collapse in={showForm} className="collapse-info">
          <div className="closeout-contrib-form-container">
            {showForm && (
              <React.Fragment>
                <div className="closeout-contrib-form-block">
                  <label className="closeout-contrib-form-label">
                    Notes / Comments
                  </label>
                  {readOnly ? (
                    contribForm.comments
                  ) : (
                    <TextareaAutosize
                      rows={2}
                      className={classnames({
                        'text-area': true,
                        'input-area': true,
                        'form-control': true,
                      })}
                      placeholder="Enter Text Here..."
                      onBlur={(e) =>
                        this.handleContribFormChange(
                          'comments',
                          e.target.value,
                          this.handleSave
                        )
                      }
                      defaultValue={contribForm.comments}
                    />
                  )}
                </div>
                {closeoutContrib.closeout_contributor_cats
                  .sort((contribCat1, contribCat2) =>
                    contribCat1.id < contribCat2.id ? -1 : 1
                  )
                  .map((contribCat) => {
                    return (
                      <React.Fragment key={contribCat.id}>
                        <p>
                          <b>{contribCat.closeout_cat.label}</b>
                        </p>
                        {readOnly ? (
                          !contribForm[contribCat.id].applies && (
                            <div className="closeout-contrib-form-block">
                              <label className="closeout-contrib-form-label">
                                Not Applicable
                              </label>
                            </div>
                          )
                        ) : (
                          <div className="closeout-contrib-form-block">
                            <label className="closeout-contrib-form-label">
                              Not Applicable
                            </label>
                            <LabeledCheckBox
                              onChange={(value) =>
                                this.handleContribFormCatChange(
                                  contribCat.id,
                                  'applies',
                                  !value,
                                  this.handleSave
                                )
                              }
                              checked={!contribForm[contribCat.id].applies}
                            />
                          </div>
                        )}
                        {contribForm[contribCat.id].applies && (
                          <React.Fragment>
                            {contribCat.closeout_cat.value === 'misc' && (
                              <div className="closeout-contrib-form-block">
                                <label className="closeout-contrib-form-label">
                                  Notes / Comments
                                </label>
                                {readOnly ? (
                                  contribForm[contribCat.id].comments
                                ) : (
                                  <TextareaAutosize
                                    rows={2}
                                    className={classnames({
                                      'text-area': true,
                                      'input-area': true,
                                      'form-control': true,
                                    })}
                                    placeholder="Enter Text Here..."
                                    onBlur={(e) =>
                                      this.handleContribFormCatChange(
                                        contribCat.id,
                                        'comments',
                                        e.target.value,
                                        this.handleSave
                                      )
                                    }
                                    defaultValue={
                                      contribForm[contribCat.id].comments
                                    }
                                  />
                                )}
                              </div>
                            )}
                            <div className="closeout-contrib-form-block">
                              <label className="closeout-contrib-form-label">
                                Documents
                              </label>
                              <div className="closeout-contrib-form-block-docs">
                                {contribForm[contribCat.id] &&
                                  contribForm[contribCat.id].documents &&
                                  contribForm[contribCat.id].documents.map(
                                    (doc, index) => {
                                      return (
                                        <div className="doc-viewer" key={index}>
                                          {!readOnly && (
                                            <img
                                              className="remove-doc-icon"
                                              src={removeIconPng}
                                              alt="remove"
                                              onClick={() =>
                                                this.confirmRemoveDocument(
                                                  contribCat.id,
                                                  index
                                                )
                                              }
                                            />
                                          )}
                                          <DocumentLink
                                            file={doc}
                                            url={doc.url}
                                          />
                                        </div>
                                      );
                                    }
                                  )}
                                {!readOnly && (
                                  <Dropzone
                                    accept="application/pdf"
                                    className="dropzone-container"
                                    onDropAccepted={(files) =>
                                      this.setDocuments(contribCat.id, files)
                                    }
                                    onDropRejected={
                                      this.handleShowInvalidDocsMsg
                                    }
                                  >
                                    <div>
                                      <img src={uploadSvg} alt="upload" />
                                      <span>
                                        Please drag and drop any PDF file into
                                        this area
                                      </span>
                                    </div>
                                  </Dropzone>
                                )}
                              </div>
                            </div>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    );
                  })}
                {showRemoveConfirmation && (
                  <ConfirmationModal
                    show={showRemoveConfirmation}
                    message="Are you sure you want to delete this document?"
                    onHide={this.removeDocument}
                  />
                )}
                {showInvalidDocsMsg && (
                  <MessageModal
                    show={showInvalidDocsMsg}
                    icon={invalidPng}
                    message="File format not supported. Please try uploading again as PDF."
                    onHide={this.handleDismissInvalidDocsMsg}
                  />
                )}
              </React.Fragment>
            )}
          </div>
        </Collapse>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    currentProject: getCurrentProject(state),
  };
})(CloseoutContribForm);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-closeout/CloseoutContribForm.js